import React from 'react'

export const Step1 = () => {
  return (
    <div>
      <div>
        <div> <h2> Keg Reservation </h2> </div>
        <div> <label> Step 1: Pick Your Beer </label> </div>
      </div>
      <div className={'reservation-steps'}>
        <div className={'reservation-step-colored'} />
        <div className={'reservation-step'} />
        <div className={'reservation-step'} />
      </div>
    </div>
  )
}

export const Step2 = () => {
  return (
    <div>
      <div>
        <div> <h2> Keg Reservation </h2> </div>
        <div> <label> Step 2: Personal Information </label> </div>
      </div>
      <div className={'reservation-steps'}>
        <div className={'reservation-step-colored'} />
        <div className={'reservation-step-colored'} />
        <div className={'reservation-step'} />
      </div>
    </div>
  )
}

export const Step3 = () => {
  return (
    <div>
      <div>
        <div> <h2> Keg Reservation </h2> </div>
        <div> <label> Step 3: Order Summary </label> </div>
      </div>
      <div className={'reservation-steps'}>
        <div className={'reservation-step-colored'} />
        <div className={'reservation-step-colored'} />
        <div className={'reservation-step-colored'} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Reservations/Steps.jsx